// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const batchClearanceDefinitionId = (z.number());
export const batchClearanceDefinition = z.object({
    id: batchClearanceDefinitionId,
    name: z.string(),
    description: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    default_responsible_operator_id: operatorId.nullable(),
});
export const batchClearanceDefinitionInitializer = z.object({
    id: batchClearanceDefinitionId.optional(),
    name: z.string(),
    description: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    default_responsible_operator_id: operatorId.optional().nullable(),
});
export const batchClearanceDefinitionMutator = z.object({
    id: batchClearanceDefinitionId.optional(),
    name: z.string().optional(),
    description: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    default_responsible_operator_id: operatorId.optional().nullable(),
});
//# sourceMappingURL=BatchClearanceDefinition.js.map